var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.93449 0 0 4.93472 0 11C0 17.0653 4.93449 22 11 22C17.0655 22 22 17.0653 22 11C22 4.93472 17.0655 0 11 0ZM11 19.7608C6.16918 19.7608 2.23919 15.8308 2.23919 11C2.23919 6.16918 6.16918 2.23919 11 2.23919C15.8308 2.23919 19.7608 6.16918 19.7608 11C19.7608 15.8308 15.8308 19.7608 11 19.7608Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5826 9.34655C18.1391 8.80999 18.1391 7.91866 17.5826 7.38211C17.0541 6.87263 16.2172 6.87263 15.6888 7.38211L9.73203 13.1247L7.29836 10.8358C6.7657 10.3348 5.93275 10.343 5.41008 10.8544C4.85575 11.3968 4.86457 12.2915 5.42948 12.8229L8.74185 15.9382C9.06781 16.2448 9.50624 16.3607 9.91719 16.2873C10.2288 16.2673 10.5349 16.1409 10.7765 15.908L17.5826 9.34655Z",
    fill: "#575757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon_checkCircle.d108a73f67338ed4b38025bddd0f1e7c.svg";
export { ForwardRef as ReactComponent };